import { render, staticRenderFns } from "./VSpacer.vue?vue&type=template&id=741ab1e2&functional=true&"
import script from "./VSpacer.vue?vue&type=script&lang=js&"
export * from "./VSpacer.vue?vue&type=script&lang=js&"
import style0 from "./VSpacer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports